/**
 * @module tree/before
 */

/**
 * @typedef {String|Number|DocumentFragment|Element|Text} Content
 */

import fragment from './fragment.js'

/**
 * Adds some contents to a node, before the provided target
 * @param {Document|DocumentFragment|Element} target
 * @param {...Content} contents
 */
export default (
  target,
  ...contents
) => {
  const { ownerDocument, parentNode } = target

  parentNode.insertBefore(fragment(contents, ownerDocument), target)
}
